import InviteLeadsFromPreviousDeals from './InviteLeadsFromPreviousDeals.component';

export default InviteLeadsFromPreviousDeals;